import {configurationType} from "./types/ConfType";

export const conf: configurationType = {
  api: {
    uri: process.env.REACT_APP_API_URI ?? '',
    debug: process.env.REACT_APP_API_DEBUG === 'true'
  }
}
